export default {
  strict: true,
  namespaced: true,
  state: {
    shiftForm: {
      show: false,
      forHomeSector: false,
      title: 'Creating new shift',
      isEdit: false,
      save: false,
      shiftId: null,
      shiftDay: null,
      timeHour: 1,
      timeMinute: 0,
      timeAmPm: 'AM',
      shiftDuration: 1,
      sectors: [],
      selectedSector: -1,
      subsectors: [],
      selectedSubsector: -1
    }
  },
  mutations: {
    setShiftFormShow (state, value) { state.shiftForm.show = value },
    setShiftFormForHomeSector (state, value) { state.shiftForm.forHomeSector = value },
    setShiftFormTitle (state, value) { state.shiftForm.title = value },
    setShiftFormIsEdit (state, value) { state.shiftForm.isEdit = value },
    setShiftFormSave (state, value) { state.shiftForm.save = value },
    setShiftFormShiftId (state, value) { state.shiftForm.shiftId = value },
    setShiftFormShiftDay (state, value) { state.shiftForm.shiftDay = value },
    setShiftFormTimeHour (state, value) { state.shiftForm.timeHour = value },
    setShiftFormTimeMinute (state, value) { state.shiftForm.timeMinute = value },
    setShiftFormTimeAmPm (state, value) { state.shiftForm.timeAmPm = value },
    setShiftFormShiftDuration (state, value) { state.shiftForm.shiftDuration = value },
    setShiftFormSectors (state, value) { state.shiftForm.sectors = value },
    setShiftFormSelectedSector (state, value) { state.shiftForm.selectedSector = value },
    setShiftFormSubsectors (state, value) { state.shiftForm.subsectors = value },
    setShiftFormSelectedSubsector (state, value) { state.shiftForm.selectedSubsector = value }
  }
}



// WEBPACK FOOTER //
// ./src/store/provider/shift-form.js